import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import VueSweetalert2 from 'vue-sweetalert2'
import NProgress from 'nprogress'
import Viewer from 'v-viewer'

import {
  Row,
  Col,
  Menu,
  MenuItem,
  MenuGroup,
  Submenu,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Icon,
  BackTop,
  Spin,
  Tooltip,
  Button,
  ButtonGroup,
  Card,
  Select,
  Option,
  Input
} from 'iview'
Vue.component('Row', Row)
Vue.component('Col', Col)
Vue.component('Menu', Menu)
Vue.component('MenuItem', MenuItem)
Vue.component('MenuGroup', MenuGroup)
Vue.component('Submenu', Submenu)
Vue.component('Dropdown', Dropdown)
Vue.component('DropdownMenu', DropdownMenu)
Vue.component('DropdownItem', DropdownItem)
Vue.component('Icon', Icon)
Vue.component('BackTop', BackTop)
Vue.component('Spin', Spin)
Vue.component('Tooltip', Tooltip)
Vue.component('Button', Button)
Vue.component('ButtonGroup', ButtonGroup)
Vue.component('Card', Card)
Vue.component('Select', Select)
Vue.component('Option', Option)
Vue.component('Input', Input)

//引入样式
import 'nprogress/nprogress.css'
import './styles/app.scss'
import 'viewerjs/dist/viewer.css'
import 'iview/dist/styles/iview.css'

// import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/css/swiper.css'
// Vue.use(VueAwesomeSwiper)

Vue.use(Viewer)

Vue.config.productionTip = false

Vue.use(VueSweetalert2)

NProgress.inc(0.2)
NProgress.configure({ easing: 'ease', speed: 500, showSpinner: false })

router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})

router.afterEach(() => {
  NProgress.done()
})

window.vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
